@let noComments = !store.isGov || !commentService.allComments().length;
<o-toc-item-header [dataSource]="dataSource" [displayReady]="true" [emptyMessage]="'empty.comments' | translate">
  <div class="select-expand-actions" selectAll>
    @if (!noComments) {
      @if (canManageAtLeastOneComment()) {
        <span class="select-all-btn" (click)="toggleAllSelection()">
          {{ (selectMode() ? "actions.unselectAll" : "actions.selectAll") | translate }}
        </span>
      }
      <span class="collapse-all-btn" (click)="toggleExpansionAll()">
        {{ (expanded ? "actions.reduceAll" : "actions.expandAll") | translate }}
      </span>
    }
  </div>
  <div class="action-button" actions>
    <button
      mat-icon-button
      class="button-icon"
      title="delete-list-action"
      type="button"
      [disabled]="noComments"
      [mat-menu-trigger-for]="deleteMenu">
      <mat-icon class="icon" color="primary" svgIcon="delete" />
    </button>
    <button
      mat-icon-button
      class="button-icon"
      title="import-action"
      type="button"
      [disabled]="!store.offlineSearchReady"
      (click)="importCommentsInput.click()">
      <mat-icon class="icon" color="primary" svgIcon="file-upload" />
    </button>
    <button
      mat-icon-button
      class="button-icon"
      title="export-list-action"
      type="button"
      [disabled]="noComments"
      [mat-menu-trigger-for]="exportMenu">
      <mat-icon class="icon" color="primary" svgIcon="export" />
    </button>
  </div>
</o-toc-item-header>

<mat-table mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="{{ itemType }}">
    <mat-header-cell mat-header-cell *matHeaderCellDef> {{ itemType }} </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element">
      @let noRight = element.author !== store.user.userName && !store.user.canManageAllComments;
      <mat-checkbox
        disableRipple
        [class.hide]="noRight"
        [name]="element._id"
        (click)="toggleSelection(element._id)"
        [checked]="selectionModel.isSelected(element._id)"
        [disabled]="!element.title || noRight" />
      <o-comment
        oHistoric
        [historicData]="element"
        [from]="historySource.COMMENTS"
        [comment]="element"
        [expanded]="expanded" />
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>

<mat-menu #deleteMenu="matMenu" class="comment-delete-menu">
  <button
    mat-menu-item
    class="comment-delete"
    type="button"
    (click)="deleteSelected()"
    [disabled]="!selectionModel?.selected?.length">
    {{ "actions.delete.selection" | translate }}
  </button>
  <button
    mat-menu-item
    class="comment-delete"
    type="button"
    [disabled]="!canManageAtLeastOneComment()"
    (click)="deleteAll()">
    {{ "actions.delete.all" | translate }}
  </button>
</mat-menu>

<mat-menu #exportMenu="matMenu" class="comment-export-menu">
  <button
    mat-menu-item
    class="comment-export"
    type="button"
    (click)="exportSelection()"
    [disabled]="!selectionModel?.selected?.length">
    <mat-icon color="primary" svgIcon="export" />
    {{ "actions.export.selection" | translate }}
  </button>
  <button
    mat-menu-item
    class="comment-export"
    type="button"
    (click)="exportSelectionWithDDN()"
    [disabled]="!selectionModel?.selected?.length">
    <mat-icon color="primary" svgIcon="export" />
    {{ "comments.ddn.export" | translate }}
  </button>
</mat-menu>

<input
  type="file"
  (change)="importComments($event)"
  accept=".zip"
  #importCommentsInput
  id="import-comments-input"
  title="import comments input" />
